
import vue from "vue";
import {
addDay,
setSessionStorage,
getSessionStorage,
removeSessionStorage
} from "@/common/js/utils.js";
import {
initWxJSSDK,
createActivityOrderYuexiu,
getDefaultAddress,
checkOpenArea,
getPartner
} from "@/common/js/api.js";

import wx from "weixin-js-sdk";

import Toast from 'vux/src/components/toast/index.vue'
import Picker from 'vux/src/components/picker/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Box from 'vux/src/components/box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Radio from 'vux/src/components/radio/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'

import { getCookie } from "@/common/js/utils";

export default {
directives: {
TransferDom
},
components: {
Toast,
Picker,
PopupPicker,
XHeader,
Box,
XButton,
XInput,
Group,
CellBox,
Cell,
Scroller,
Icon,
Search,
Flexbox,
FlexboxItem,
TransferDom,
Radio,
Popup,
Grid,
GridItem,
GroupTitle,
Swiper,
SwiperItem,
Tabbar,
Tab,
TabItem,
XDialog
},
methods: {
changeShowOpenCityDialog() {
this.showOpenCityDialog = !this.showOpenCityDialog;
},
changeShowAppointmentDialog() {
this.showAppointmentDialog = !this.showAppointmentDialog;
},
changeShowExplainDialog() {
this.showExplainDialog = !this.showExplainDialog;
},
goMain() {



const self = this
console.log(self.miniprogram)
self.miniprogram = getCookie('miniprogram')
if (self.miniprogram == 1 || self.miniprogram == '1') {
wx.miniProgram.navigateTo({
url:"/pages/index",
fail: () =>  {
self.$vux.toast.text('小程序更新中,请稍后再试!', 'middle')
}
})
} else {
this.$router.push({
path: "/main"
});
}
},
changeCondition() {
this.condition = !this.condition;
},
getResult(val) {
this.results = val ? getResult(this.value) : [];
},
onSubmit(val) {
let self = this;
if (this.entity.weight == "") {
this.view.toast = true;
this.view.toastText = "请选择预估衣物重量";
return;
}

this.$vux.confirm.show({

title: "提醒您",
content: "确定下单吗？",
onCancel() {},
onConfirm() {
self.appointment();
}
});
},
appointment() {
let self = this;
createActivityOrderYuexiu({ data: this.entity }).then(function(data) {
self.$router.push({ path: "/usercenter/orderList" });
});
},
onChange(v) {},

weightChange(v) {
console.log(v);
},
confirmWeight() {
if (this.view.weightDefault == 0) {
this.view.toast = true;
this.view.toastText = "5KG以下(暂不回收)";
} else {
this.view.openWeightPicker = !this.view.openWeightPicker;
this.entity.weight = this.getSelectValue(
this.view.weightDefault,
this.weights[0]
);
this.view.weightText = this.getSelectText(
this.view.weightDefault,
this.weights[0]
);
}
},
pickWeight(item) {
if (item.status == 0) {
return;
}
this.view.weightDefault = item.value;
},
getSelectText(val, ls) {
for (var i = 0; i < ls.length; i++) {
if (ls[i].value == val) {
return ls[i].name;
}
}
return "";
},
getSelectValue(val, ls) {
for (var i = 0; i < ls.length; i++) {
if (ls[i].value == val) {
return ls[i].value;
}
}
return "";
},
initShare() {
let self = this;
self.$wechat.onMenuShareTimeline({
title: self.share.shareTitle, // 分享标题
link: self.share.shareUrl, // 分享链接
imgUrl:
window.location.protocol +
"//" +
window.location.hostname +
"/static/images/logo.png", // 分享图标
success: function() {
},
cancel: function() {

}
});
self.$wechat.onMenuShareAppMessage({
title: self.share.shareTitle,
link: self.share.shareUrl, // 分享链接
imgUrl:
window.location.protocol +
"//" +
window.location.hostname +
"/static/images/logo.png", // 分享图标
desc: self.share.shareDesc,
type: "link",
dataUrl: "",
success: function() {

},
cancel: function() {

}
});
}
},
data() {
return {
bannerImgs:['ad_2019072404.png','ad_2019010203.jpg'],
bannerList: [],
showOpenCityDialog: false,
showAppointmentDialog: false,
showExplainDialog: false,
showServiceMenu: true,
partner: {},
pageInfo: {
pageIndex: 1,
pageSize: 10,
keyword: "",
extInfo: undefined
},
view: {
openWeightPicker: false,
toast: false,
toastText: "",
openTimePicker: false,
openAddressPicker: false,
weightText: "请选择预估衣物重量",
appointTimeDefault: [],
weightDefault: "2",
address: "请选择收件地址",
areaCode: "",
isAreaSupport: false
},
entity: {
activityId: "",
qrId: "",
weight: "",
partnerId: ""
},
todayDate:"",
weights: [
[
{ name: "5KG以下(暂不回收)", value: "0", status: 0 },
{ name: "5-15KG(约17件)", value: "1", status: 1 },
{ name: "15-25KG(约37件)", value: "2", status: 1 },
{ name: "25-35KG(约60件)", value: "3", status: 1 },
{ name: "35KG以上(约75件以上)", value: "4", status: 1 }
]
],
times: [],
share: {
shareTitle: "闲置衣物回收",
shareDesc: "闲置衣物回收",
shareUrl: ""
},
partnerId: "",
appointImage: "",
btnStyle: "",
bannerImage: "",
miniprogram: 0
};
},
created() {
let self = this
let activityId = this.$route.query.activityId;

if (this.$route.query.activityId) {
this.entity.activityId = this.$route.query.activityId;
}
if (this.$route.query.partnerId) {
this.entity.partnerId = this.$route.query.partnerId;
}
if (this.$route.query.qrId) {
this.entity.qrId = this.$route.query.qrId;
}


let insertImgs = "https://wx.test.oouyan.cn/upload/earth/images/appointment/";
if( window.location.origin.indexOf("wx.oouyan.cn")>-1 ){
insertImgs = "https://cdn.oouyan.com/upload/earth/images/appointment/";
}
for( var i=0;i<self.bannerImgs.length;i++ ){
let obj = {url: 'javascript:',src: insertImgs+self.bannerImgs[i]};
self.bannerList.push( obj );
}
let now = new Date();
this.todayDate = now.Format("yyyy-MM-dd");
console.log( this.todayDate )
},
activated() {

}
};



// WEBPACK FOOTER //
// ./src/components/activity/yuexiu/activityappointment.vue